<template>
  <div></div>  
</template>


<script>
export default {
 data() {
      return {
      }
    },
  created(){
    window.open("/idaas-admin","_self")
  },
  methods: {
    handleRowSave(obj){

    },
    handleRowUpdate(obj){

    },
  }
}
</script>
